import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LimberChefProduto } from 'src/app/models/limber-chef-produto';
import { Licenca, Registro, RegistroLicenca } from 'src/app/models/registro';
import { RegistroProduto, softwares } from 'src/app/models/registro-produto';
import { AbstractService } from 'src/app/services/abstract.service';
import { RegistroService } from 'src/app/services/registro.service';
import { clone } from 'src/app/utilities/util/clone-utils';
import { DateUtils } from 'src/app/utilities/util/date-utils';
import { FormatUtils } from 'src/app/utilities/util/format-utils';

@Component({
  selector: 'habil-altera-licenca',
  templateUrl: './altera-licenca.component.html',
  styleUrls: ['./altera-licenca.component.scss']
})
export class AlteraLicencaComponent implements OnInit {

  loading = false;

  search = '';

  registro: Registro;

  modulos: RegistroProduto[];
  modulosChef: LimberChefProduto[];

  licenca: {
    licenca: Licenca;
    registroLicenca: RegistroLicenca;
    oldTrial: number
  }[] = [];

  constructor(private registroService: RegistroService,
    private route: ActivatedRoute, private router: Router
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const token = params['token'];

      if (token) {
        AbstractService.saveToLocalStorage('token', token);

        const newParams = { ...params };
        delete newParams['token'];

        this.router.navigate([], {
          queryParams: newParams,
          replaceUrl: true,
        });
      }
    });
  }


  addTrial(rl: { trial: number } | any, dias: number) {
    rl.trial = dias
  }

  vencimento(lic: RegistroLicenca | any): Date {
    const rl = lic?.registroLicenca;
    const result = new Date(rl.expDate || rl.val);
    if (lic.oldTrial > 0) {
      return result;
    }
    if (rl?.trial > 0) {
      try {
        const daysBetween = DateUtils.daysBetween(new Date(), new Date(rl.expDate || rl.val));
        result.setDate(result.getDate() + Number(rl?.trial + daysBetween));
        return result;

      } catch (error) {

      }
    }

    return new Date(rl.expDate || rl.val);
  }

  salvar(lic: {
    licenca: Licenca;
    registroLicenca: RegistroLicenca;
    oldTrial: number
  }) {
    this.loading = true;
    if (lic.oldTrial > lic.registroLicenca.trial) {
      const trial = lic.registroLicenca.trial - lic.oldTrial;
      const result = new Date((lic.registroLicenca.expDate || lic.registroLicenca.val));
      result.setDate(result.getDate() + Number(trial));
      (lic.registroLicenca.expDate ? lic.registroLicenca.expDate = result : lic.registroLicenca.val = result);
    }
    if (lic.registroLicenca.trial) {
      const trial = lic.registroLicenca.trial - lic.oldTrial;
      const result = new Date((lic.registroLicenca.expDate || lic.registroLicenca.val));
      const daysBetween = DateUtils.daysBetween(new Date(), (lic.registroLicenca.expDate ? new Date(lic.registroLicenca.expDate) : new Date(lic.registroLicenca.val)));

      result.setDate(result.getDate() + Number(trial + daysBetween));
      lic.registroLicenca.trial = trial + daysBetween;
      if (trial > 0) {
      (lic.registroLicenca.expDate ? lic.registroLicenca.expDate = result : lic.registroLicenca.val = result);
      }

    }
    if (lic.registroLicenca.trial < 0) {
      lic.registroLicenca.trial = 0;
    }
    if (lic.registroLicenca.emissoes?.length) {
      for (const e of lic.registroLicenca.emissoes) {
        if (e.nfe) {
          e.vctoNfe = lic.registroLicenca.expDate;
        }
        if (e.nfce) {
          e.vctoNfce = lic.registroLicenca.expDate;
        }
        if (e.nfs) {
          e.vctoNfs = lic.registroLicenca.expDate;
        }
      }
    }

    this.registroService
      .saveRegistroLicenca(this.registro.id, lic.licenca, lic.registroLicenca)
      .subscribe(
        (ret) => {
          this.loading = false;
          this.registro = null;
          this.licenca = [];
        },
        (e) => {
          this.registroService.handleError(e);
          this.loading = false;
        }
      );
  }

  isMaiorQue5Dias(rl: RegistroLicenca | any): boolean {
    const data = new Date(rl.expDate || rl.val);
    const agora = new Date();

    const diffMs = data.getTime() - agora.getTime();
    const diffDias = diffMs / (1000 * 60 * 60 * 24);
    return diffDias > 5;
  }

  buscarDadosLicenca() {
    if (this.loading) {
      return;
    }
    this.licenca = [];
    this.registro = null;
    this.loading = true;
    this.search = (this.search as any).replaceAll(' ', '').replaceAll('	', '');
    if (!this.search) {
      this.loading = false;
      return;
    }
    const search = this.search + '';
    this.registroService.findByCnpj(FormatUtils.clear(search)).subscribe({
      next: async (value) => {
        this.loading = false;
        this.licenca = [];
        if (value?.[0]?.id) {
          this.search = '';
          this.registro = value[0];
          for (const licenca of this.registro.licencas) {
            const ret = await this.registroService
              .getRegistroLicenca(this.registro.id, licenca.software)
              .toPromise();
            if (ret?.body) {
              for (const m of licenca.modulosLicenciados) {
                m.descricaoModulo =
                  licenca.software == "HABIL_10"
                    ? this.modulos?.find((mod) => mod?.id == m?.idModulo)
                      ?.nomeProduto || "(não encontrado)"
                    : this.modulosChef?.find((mod) => mod?.id == m?.idModulo)
                      ?.nomeProduto || "(não encontrado)";
              }
              const reg: RegistroLicenca = clone(ret.body);
              this.licenca.push({
                licenca: licenca,
                registroLicenca: reg,
                oldTrial: reg.trial || 0
              });
            }
          }
        }
      },
      error: (err) => {
        this.loading = false;
        this.registroService.handleError(err);
      },
    });
  }

  getSoftware(value: string) {
    if (value) {
      return (
        softwares.find((s) => s.value == value)?.label || "(não encontrado)"
      );
    }
    return "(nenhum)";
  }

}
